/* Spanish catalog mirroring locale-pension-invoice-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'otp.sourceRequired': 'Documento de la bandeja de entrada o compra existente',
  'otp.positivePremium': 'Prima de pensión mayor que cero',
  'otp.completeBeforePreview': 'Completa o selecciona antes de previsualizar el asiento:',
  'otp.unlinked': 'Devengos de nómina sin vínculo con una factura',
  'otp.alreadyPosted': 'Coste y pago contabilizados anteriormente',
  'otp.noAccruals': 'No hay devengos de nómina disponibles. Los devengos pagados anteriormente deben corregirse antes de vincularlos a una factura.',
  'otp.inboxNotice': 'Esto parece una factura de pensión (OTP). Regístrala a través de Pensión/OTP para conciliar los devengos de nómina y gestionar las cotizaciones del empleador.',
  'otp.open': 'Abrir en Pensión/OTP',
  'otp.dismiss': 'Esto no es OTP',
  'otp.invoices': 'Facturas de pensión y asignaciones',
  'otp.register': 'Registrar factura de pensión',
  'otp.flow': 'Primero vincula la factura a los devengos de nómina. Registra cada pago una sola vez contra la factura. Las cotizaciones del empleador siguen el mes real del pago.',
  'otp.invoice': 'Factura',
  'otp.actual': 'Coste real',
  'otp.accrued': 'Devengo asignado',
  'otp.paid': 'Pagado',
  'otp.remaining': 'Pendiente',
  'otp.aga': 'Cotización del empleador procesada',
  'otp.reported': 'Declaración registrada',
  'otp.notReported': 'Declaración no registrada',
  'otp.reportingReview': 'Revisar a-melding',
  'otp.reportingWarning': 'Ya hay una a-melding registrada para el mes del pago. Puedes registrar el pago, pero debes revisar y, si es necesario, corregir la a-melding con la base actualizada de pensión y cotización del empleador. El envío anterior no se modifica automáticamente.',
  'otp.annulled': 'Vínculo revertido',
  'otp.details': 'Ver detalles',
  'otp.document': 'Documento de la bandeja de entrada',
  'otp.existing': 'Vincular compra existente',
  'otp.supplierName': 'Proveedor',
  'otp.invoiceNumber': 'Número de factura',
  'otp.invoiceDate': 'Fecha de factura',
  'otp.dueDate': 'Fecha de vencimiento',
  'otp.date': 'Fecha de asignación',
  'otp.premium': 'Prima de pensión del empleador',
  'otp.administration': 'Administración de pensiones (sin IVA)',
  'otp.components': 'Confirma que los importes cubren la prima del empleador y la administración de pensiones sin IVA. Las aportaciones de los empleados, las comisiones de traspaso y otros componentes requieren una revisión aparte antes de usar este flujo.',
  'otp.selectAccruals': 'Selecciona los devengos de nómina cubiertos por la factura',
  'otp.preview': 'Previsualizar asiento',
  'otp.difference': 'Diferencia con el devengo',
  'otp.existingPreview': 'La compra y el pago existentes se conservan. A continuación solo se muestran la asignación y cualquier reclasificación. Los importes positivos son cargos en el Debe; los negativos son abonos en el Haber.',
  'otp.newPreview': 'La factura se contabiliza en 5950 contra el pasivo con el proveedor 2400. A continuación se muestra la asignación de los devengos anteriores. Los importes positivos son cargos en el Debe; los negativos son abonos en el Haber. Registra el pago por separado.',
  'otp.confirm': 'Confirmar factura y asignación',
  'otp.saved': 'Registro de OTP guardado.',
  'otp.purchasePosting': 'Ver asiento de la compra',
  'otp.allocationPosting': 'Ver asignación',
  'otp.paymentDocumented': 'Registra solo un pago documentado que no se haya contabilizado ya. Esto no transfiere dinero.',
  'otp.reversePayment': 'Revertir pago',
  'otp.annulLink': 'Revertir asignación',
  'otp.annulExplanation': 'Se revierten la asignación y las cotizaciones del empleador vinculadas. La factura de compra y el pago se mantienen. Después, vincula de nuevo la factura con los devengos correctos. Esto no modifica una transferencia bancaria.',
});
